import _cloneDeep from 'lodash/cloneDeep';

export default {
  vehicleCapture: state => _cloneDeep(state.vehicleCapture),
  vehicleCaptures: state => _cloneDeep(state.vehicleCaptures),
};
